import { Component, createRef } from 'react';
import 'whatwg-fetch';
import { Popup } from 'devextreme-react/popup';
import {
  DataGrid,
  Column,
  Editing,
  Scrolling,
  Selection,
  SearchPanel,
  ColumnChooser,
  Grouping,
  GroupPanel,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  Search,
  SortByGroupSummaryInfo,
  Button,
} from 'devextreme-react/data-grid';
import { EditMemberForm } from './edit-member-form';
import {
  calcGridHeight,
  renderPreferredFirstNameGridCell,
  addMemberBaseViewColumns,
  initMemberBaseViewColumns,
} from '~/helpers/ui';
import { AppContext } from "~/app-context"
import {
  CreateAuthorizedDataSource,
  CreateAuthorizedStore,
  loadMembersLookupDataAsync,
  disposeMembersLookupData,
} from '~/helpers/data';
import { appConst } from '~/app-const';
import { GridLayout } from '~/components/grid-layout-component/grid-layout';
import { SubImport } from '~/components/member-import/sub-import';
import { CallLogPopup } from '~/components/call-log-popup/call-log-popup';

import './members.scss';

const URL = `${window.env.apiEndpoint}/api/v1/Members`;

export class Members extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditForm: false,
      addNewMode: false,
      currentFirstName: '',
      showImportForm: false,
      popupTitle: "Loading...",
      callLogPopups: [],
    };

    this.editIconClick = this.editIconClick.bind(this);
    this.callIconClick = this.callIconClick.bind(this);
    this.hideEditPopup = this.hideEditPopup.bind(this);
    this.hideEditPopupAndRefreshGrid = this.hideEditPopupAndRefreshGrid.bind(this);
    this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
    this.windowResized = this.windowResized.bind(this);

    this.dataSource = CreateAuthorizedDataSource(
      {
        loadUrl: `${URL}/Get`,
        deleteUrl: `${URL}/Delete`,
      },null, 'Id',
    );

    this.setShowImportForm = this.setShowImportForm.bind(this);
    this.updateTitle = this.updateTitle.bind(this);
    this.editMemberFormRef = createRef();
    this.editMemberFormPopupRef = createRef();
    this.membersGridRef = createRef();
    this.truncateText = this.truncateText.bind(this);
  }

  async componentDidMount() {
    window.addEventListener('resize', this.windowResized);
    this.setState({ membersLookupData: await loadMembersLookupDataAsync() });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResized);

    if (this.dataSource && this.dataSource.isLoaded()) {
      this.dataSource.dispose();
    }
    const { membersLookupData } = this.state

    membersLookupData && disposeMembersLookupData(membersLookupData);
  }

  hideEditPopup() {
    this.setState({
      rowData: {},
      showEditForm: false,
    });
  }

  hideEditPopupAndRefreshGrid() {
    this.hideEditPopup();
    this.membersGridRef.current.instance().refresh()
      .then(() => {
        // Refresh succeeds
      })
      .catch(() => {
        // Error refesh the grid.
      });
  }

  updateTitle(newTitle) {
    this.setState({ popupTitle: newTitle || "Unable to show" });
  }


  async getMemberById(id) {
    const getMemberByIdStore = CreateAuthorizedStore(
      { loadUrl: `${URL}/GetMemberById` }, { load: { Id: id } },
    );
    getMemberByIdStore.load().then(
      (result) => result[0],
    );
  }

  editIconClick(key) {
    const getMemberByIdStore = CreateAuthorizedStore(
      { loadUrl: `${URL}/GetMemberById` }, { load: { Id: key } },
    );
    getMemberByIdStore.load().then(
      (result) => {
        this.setState({
          showEditForm: true,
          rowData: { ...result[0] },
          addNewMode: false,
        });
      },
    );
  }

  callIconClick(e) {
    const key = Date.now();
    this.setState((prev) => ({
      callLogPopups: [...prev.callLogPopups, { key, personId: e.row.data.Id }],
    }));
  }

  windowResized() {
    this.membersGridRef.current.instance().option('height', calcGridHeight('membersGrid'));
  }

  renderPopUp(isEditFormShown) {
    if (isEditFormShown) {
      const { addNewMode, rowData, membersLookupData, popupTitle } = this.state;
      return (
        <Popup
          ref={this.editMemberFormPopupRef}
          visible={isEditFormShown}
          {...appConst.defaultPopupOptions}
          className="editMemberPopup"
          title={popupTitle}
          onHiding={(e) => {
            e.cancel = true;
            this.editMemberFormRef.current.cancelData();
          }}
        >
          <EditMemberForm
            ref={this.editMemberFormRef}
            rowData={rowData}
            hideEditPopupAndRefreshGrid={this.hideEditPopupAndRefreshGrid}
            hideEditPopup={this.hideEditPopup}
            salutationsData={membersLookupData.salutationsData}
            gendersData={membersLookupData.gendersData}
            pronounsData={membersLookupData.pronounsData}
            emailAddressTypesData={membersLookupData.emailAddressTypesData}
            phoneTypesData={membersLookupData.phoneTypesData}
            addNewMode={addNewMode}
            membershipTypesData={membersLookupData.membershipTypesData}
            employmentStatusesData={membersLookupData.employmentStatusesData}
            contractTypesData={membersLookupData.contractTypesData}
            designationsData={membersLookupData.designationsData}
            ridingsData={membersLookupData.ridingsData}
            provincesData={membersLookupData.provincesData}
            updateTitle={this.updateTitle}
          />
        </Popup>
      );
    }

    return (
      <></>
    );
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift(
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'add',
          onClick: () => {
            this.setState({
              showEditForm: true,
              rowData: { EmailAddresses: [], PhoneNumbers: [], Schools: [], City: "Edmonton" },
              addNewMode: true,
            });
          },
        },
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'upload',
          hint:'upload an excel file to import',
          onClick: () => {
            this.setShowImportForm(true);
          },
        },
      },
    );
  }

  setShowImportForm(v) {
    this.setState({ showImportForm: v });
  }

  truncateText(data, colName) {
    const div =
    <div
      title={data[colName]}
      style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '300px',
      }}
    >
      {data[colName]}
      </div >;
    return div;
  }

  render() {
    const { showEditForm, showImportForm, callLogPopups } = this.state;
    return (
      <div>
        <SubImport
          visible={showImportForm}
          setShowImportForm={this.setShowImportForm}
        />
        {this.renderPopUp(showEditForm)}
        <div className="title">
          <span>Members</span>
          <GridLayout
            rememberTempLayout={true}
            layoutKey="Members"
            gridName="membersGrid"
            pageName="MembersPage"
            gridRef={() => { return this.membersGridRef.current.instance() }}
          />
        </div>
        <DataGrid
          id="membersGrid"
          ref={this.membersGridRef}
          dataSource={this.dataSource}
          {...appConst.defaultGridOptions}
          onToolbarPreparing={this.onToolbarPreparing}
          onRowDblClick={(e) => {
            this.editIconClick(e.key);
          }}
          customizeColumns={addMemberBaseViewColumns}
          onInitialized={(e) => {
            initMemberBaseViewColumns(e);
            e.component.option('height', calcGridHeight(e.component.element().id));
          }}
        >
          <Scrolling mode="virtual" rowRenderingMode="virtual" />
          <Selection mode="multiple" />
          <SearchPanel
            visible
            width={240}
            placeholder="Search..."
          />
          <Editing
            mode="popup"
            allowAdding={false}
            allowDeleting
            allowUpdating
          />
          <ColumnChooser
            enabled
            mode="dragAndDrop"
          />
          <Grouping
            allowCollapsing
            autoExpandAll={false}
            contextMenuEnabled
            expandMode="rowClick"
          />
          <GroupPanel
            visible
            allowColumnDragging
          />
          <HeaderFilter visible>
            <Search enabled={true }/>
          </HeaderFilter>
          <SortByGroupSummaryInfo
            summaryItem="count"
            sortOrder="desc"
          />
          <FilterRow visible />
          <FilterPanel visible />
          <Column dataField="Id" visible={false} />
          <Column
            dataField="PreferredFirstName"
            caption="Preferred First Name"
            sortOrder="asc"
            sortIndex="1"
            cellRender={(data) => renderPreferredFirstNameGridCell(this, data)}
          />
          <Column
            dataField="LastName"
            caption="Last Name"
            sortOrder="asc"
            sortIndex="0"
          />
          <Column
            dataField="School"
            caption="School"
          />
          <Column dataField="FirstName" caption="First Name" visible={false} />
          <Column dataField="EmailAddress" caption="Email Address" visible={false} />
          <Column dataField="PreferredEmailType" caption="Preferred Email Type" visible={false} />
          <Column dataField="PhoneNumber" caption="Phone Number" visible={false} />
          <Column dataField="PreferredPhoneType" caption="Preferred Phone Type" visible={false} />
          <Column dataField="Division" caption="Division" visible />
          <Column dataField="OtherSchools" caption="Other Schools" visible={false} />
          <Column dataField="TeachingCertificateNumber" caption="Teaching Certificate Number" visible={false} />
          <Column dataField="FullName" caption="Full Name" visible={false} />
          <Column dataField="Ward" caption="Ward" visible={false} />
          <Column dataField="Riding" caption="Riding" visible={false} />
          <Column dataField="HasError" caption="Has Error" visible={false} />
          <Column dataField="StatusMessage"
            caption="Status Message" visible={false}
            cellRender={(e) => {
              return this.truncateText(e.data, "StatusMessage");
            }}
          />
          <Column dataField="HomeHasError" caption="Home Has Error" visible={false} />
          <Column dataField="HomeStatusMessage"
            caption="Home Status Message" visible={false}
            cellRender={(e) => {
              return this.truncateText(e.data, "HomeStatusMessage");
            }}
          />
          <Column dataField="WorkHasError" caption="Work Has Error" visible={false} />
          <Column dataField="WorkStatusMessage"
            caption="Work Status Message" visible={false}
            cellRender={(e) => {
              return this.truncateText(e.data, "WorkStatusMessage");
            }}
          />
          <Column type="buttons">
            <Button name="callLog" hint="Call Log" onClick={this.callIconClick} icon="tel" />
            <Button name="edit" hint="Edit Member" onClick={(e) => this.editIconClick(e.row.key)} />
            <Button name="delete" />
          </Column>
        </DataGrid>
        {callLogPopups.map((popup, index) => (
          <CallLogPopup
            key={popup.key}
            visible
            personId={popup.personId}
            hide={() => this.setState((prev) => ({
              callLogPopups: prev.callLogPopups.filter((p) => p.key !== popup.key),
            }))}
            gridEditing={false}
            offset={`${50 * index} ${50 * index}`}
            refreshCallLogDropDownButton={() => {}}
          />
        ))}
      </div>
    );
  }
}
Members.contextType = AppContext;
